import React from 'react';
import { ClienteForm } from './ClienteForm';
import type { Cliente } from '../../types/entities';

interface Props {
  cliente?: Cliente;
  onClose: () => void;
  onSuccess?: (cliente: Cliente) => void;
}

export const ClienteFormModal: React.FC<Props> = ({ cliente, onClose, onSuccess }) => {
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] backdrop-blur-sm">
        <div className="bg-white w-[95vw] max-w-[1000px] max-h-[90vh] rounded-2xl shadow-2xl overflow-hidden">
          {/* Header */}
          <div className="bg-white border-b border-gray-200 px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <div className="w-6 h-6 bg-gray-100 rounded-md flex items-center justify-center">
                  <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 3v4a2 2 0 002 2h10a2 2 0 002-2V3" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 21h10a2 2 0 002-2V9H5v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-sm font-medium text-gray-900">{cliente ? 'Editar Cliente' : 'Novo Cliente'}</h3>
                  <div className="flex items-center space-x-4 text-xs text-gray-500 mt-0.5">
                    {cliente?.nome && <span className="flex items-center gap-1">{cliente.nome}</span>}
                    {cliente?.cpfCnpj && <span className="flex items-center gap-1">{cliente.cpfCnpj}</span>}
                  </div>
                </div>
              </div>
              <button onClick={onClose} className="w-6 h-6 bg-gray-100 hover:bg-gray-200 rounded-md flex items-center justify-center text-gray-600 transition-colors">
                <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="overflow-y-auto max-h-[calc(90vh-60px)] bg-gray-50">
            <div className="p-6">
              <ClienteForm cliente={cliente} onSuccess={(c) => { onSuccess?.(c); onClose(); }} onCancel={onClose} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ClienteFormModal;
